{
  "dsn": "https://c2145fdf47364e70ba1b90f6d4ec1c01@o475413.ingest.sentry.io/5709903",
  "release": "eip-app-5fd79ab3f928c3dbbe941b4557d68ceca1342362"
}
